export const validateMails = (selector) => {
  function validateEmail(email) {
    var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return re.test(email)
  }
  let validated = false

  const inputEmails = document.querySelectorAll(selector)

  if (inputEmails) {
    inputEmails.forEach((emailInput) => {
      emailInput.addEventListener('blur', function () {
        if (!validateEmail(emailInput.value)) {
          emailInput.parentNode.querySelector('.form-error').style.display =
            'block'
          emailInput.parentNode.querySelector('.form-error').textContent =
            'The email format is incorrect'
          validated = false
        } else {
          emailInput.parentNode.querySelector('.form-error').style.display =
            'none'
          validated = true
        }
      })
    })
  }
  return validated
}

export const validateMail = (selector) => {
  function validateEmail(email) {
    var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return re.test(email)
  }

  const inputEmail = document.querySelector(selector)

  return validateEmail(inputEmail.value)
}

export const validatePassword = (selector, showErrors = false) => {
  const passwordInput = document.querySelector(selector)
  // console.log(passwordInput)
  const passwordErrorWrapper = passwordInput.parentNode.querySelector(
    '.form-error'
  )

  let validated = false

  // console.log(passwordInput)

  if (passwordInput) {
    let password
    passwordInput.addEventListener('blur', (e) => {
      password = passwordInput.value
      if (!password.length) {
        passwordErrorWrapper.textContent = 'Password must be non-empty string'
        passwordErrorWrapper.style.display = 'block'
      } else if (password.length < 8) {
        passwordErrorWrapper.textContent =
          'Password length must be more than 8 symbols'
        passwordErrorWrapper.style.display = 'block'
      } else {
        passwordErrorWrapper.style.display = 'none'
      }
    })

    password = passwordInput.value

    if (!password.length) {
      if (showErrors) {
        passwordErrorWrapper.textContent = 'Password must be non-empty string'
        passwordErrorWrapper.style.display = 'block'
      }
      validated = false
    } else if (password.length < 8) {
      if (showErrors) {
        passwordErrorWrapper.textContent =
          'Password length must be more than 8 symbols'
        passwordErrorWrapper.style.display = 'block'
      }
      validated = false
    } else {
      validated = true
    }
  }

  return validated
}
